import { ApolloClient, ApolloLink, NormalizedCacheObject } from '@apollo/client';
import { ApolloCache } from '@apollo/client/cache';
import { setContext } from '@apollo/client/link/context';
import { createHttpLink } from '@apollo/client/link/http';
import { RetryLink } from '@apollo/client/link/retry';

export const _httpLink = (uri: string) =>
  createHttpLink({
    uri,
  });

export const _retryLink = () =>
  new RetryLink({
    delay: {
      initial: 10000,
      max: Infinity,
      jitter: true,
    },
    attempts: { max: Infinity },
  });

export const _authLink = (accessToken: string) =>
  setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${accessToken}`,
      },
    };
  });

export const _client = (cache: ApolloCache<NormalizedCacheObject>, link: ApolloLink) =>
  new ApolloClient({
    cache,
    link,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    },
  });



// WEBPACK FOOTER //
// ./src/app/afb-graphql-api/helpers/apollo.helper.ts